import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link as ExternalLink } from "theme-ui";
import { Link } from "gatsby";
import { typography, colors } from "../../styles/theme";

const CustomLink = ({ url, children, openInNewTab = true }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isExternalLink = url.startsWith("http");

  const linkStyles = {
    ...typography.textMd500,
    textDecoration: "none",
    color: colors.primaryMain,
    cursor: "pointer",
  };

  if (isHovered) {
    linkStyles.textDecoration = "underline";
  }

  return (
    <>
      {isExternalLink ? (
        <ExternalLink
          href={url}
          target={openInNewTab ? "_blank" : "_self"}
          style={linkStyles}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          rel={openInNewTab ? "noopener noreferrer" : ""}
        >
          {children}
        </ExternalLink>
      ) : (
        <Link
          style={linkStyles}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          to={url}
        >
          {children}
        </Link>
      )}
    </>
  );
};

CustomLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  openInNewTab: PropTypes.bool,
};

CustomLink.defaultProps = {
  url: "#",
  children: "Custom Link",
};

export default CustomLink;
